import type { Order } from '@/types/sorting'

export const getOrdering = (params: {
  sort?: string | undefined
  order?: Order | undefined
}) =>
  params.sort && params.order
    ? `${params.order === 'desc' ? '-' : ''}${params.sort}`
    : undefined
